import { httpV1 as http } from '@/services/api';

export async function document(data) {
  return http
    .post('/anti-fraud/document-verification', data)
    .then(({ data }) => data);
}

export async function documentCorban(data) {
  return http
    .post('/anti-fraud/corban/document-verification', data)
    .then(({ data }) => data);
}

export async function ocr(data) {
  return http
    .post('/anti-fraud/ocr', data)
    .then(({ data }) => data);
}
